import { render } from "./TeleCome.vue?vue&type=template&id=2ac68faa"
import script from "./TeleCome.vue?vue&type=script&lang=js"
export * from "./TeleCome.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__